import { useCallback, useMemo } from 'react';

import { retry } from 'src/utils';

import type { TpAppLovinParameters } from '@features/Analytics/types';

export const useAppLovinEvent = () => {
  const conditionCheckFunction = useCallback(
    async () => window?.axon != null,
    [],
  );

  const fetchClientEventWithRetry = useCallback(
    async ({ eventName, options }: TpAppLovinParameters) => {
      const actionFunction = async () => {
        if (options) {
          window?.axon?.('track', eventName, options);
          return;
        }

        window?.axon?.('track', eventName);
      };

      await retry({
        conditionCheckFunction,
        actionFunction,
        retryDelay: 300,
      });
    },
    [conditionCheckFunction],
  );

  return useMemo(
    () => ({
      clientEvent: ({ eventName, options }: TpAppLovinParameters) => {
        fetchClientEventWithRetry({
          eventName,
          options,
        });
      },
    }),
    [fetchClientEventWithRetry],
  );
};
